import React from "react";
import { splitParagraphIntoRichBlocks } from "../../../utils/extractOrganizedTourDailyItinerary";

const KW_SPLIT_RE = /(לא כולל|כולל|טיסות|מלון|ארוחות|סיורים|העברות)/;
const KW_TEST = /^(לא כולל|כולל|טיסות|מלון|ארוחות|סיורים|העברות)$/;

export function highlightKeywordsReact(text) {
  if (text == null || text === "") return null;
  const parts = String(text).split(KW_SPLIT_RE);
  return parts.map((part, idx) => {
    if (!part) return null;
    if (KW_TEST.test(part)) {
      return (
        <mark key={`k-${idx}-${part.length}`} className="organized-tour-itinerary__kw">
          {part}
        </mark>
      );
    }
    return part;
  });
}

export function RichParagraphBlocks({ paragraphs, paragraphClassName, listClassName }) {
  const blocks = [];
  const listCls = listClassName || "organized-tour-itinerary__bullet-list";
  (paragraphs || []).forEach((para, pi) => {
    const rich = splitParagraphIntoRichBlocks(para);
    if (!rich.length) return;
    rich.forEach((b, bi) => {
      const k = `pb-${pi}-${bi}-${b.type}`;
      if (b.type === "p") {
        blocks.push(
          <p key={k} className={paragraphClassName}>
            {highlightKeywordsReact(b.text)}
          </p>
        );
      } else {
        blocks.push(
          <ul key={k} className={listCls}>
            {b.items.map((item, ii) => (
              <li key={ii}>{highlightKeywordsReact(item)}</li>
            ))}
          </ul>
        );
      }
    });
  });
  if (!blocks.length) {
    return <p className={paragraphClassName}>—</p>;
  }
  return blocks;
}
